import { Status } from '../exams/assessmentSession/assessments.types';

export enum ProcessStatus {
  InProgress,
  Completed,
  Failed,
  ExaminerShouldReadMessages,
}

export interface SendBackAssessedExamTaskGroupSolutionsResponse {
  processStatus: ProcessStatus;
  results: SendBackAssessedExamTaskGroupSolutionsResult[];
}

export interface SendBackAssessedExamTaskGroupSolutionsResult {
  examTaskGroupSolutionScoreId: string;
  sendBackResult: SendBackResult;
  taskSolutionSheetId: string;
  examinerId: string;
  examTaskSolutionStatus: Status;
  examTasksWithoutRequiredComment: ExamTaskWithoutRequiredComment[];
}

export interface ExamTaskWithoutRequiredComment {
  examTaskName: string;
  criteriaWithoutRequiredComment: CriterionWithoutRequiredComment[];
}

export interface CriterionWithoutRequiredComment {
  criterionName: string;
  partialScoreId: string;
}

export enum SendBackResult {
  Success,
  FailedSpecialCase,
  FailedNotAssessed,
  Failed,
  FailedClosed,
  FailedMissingComments,
}

export interface SampleAssessmentSendBackResultResponse {
  result: SampleAssessmentSendBackResult;
  examTasksWithoutRequiredComment: ExamTaskWithoutRequiredComment[];
}

export enum SampleAssessmentSendBackResult {
  success,
  failedNotAssessed,
  failed,
  failedWrongState,
  failedMissingComments
}
